import React, { useRef, useEffect, useState } from "react";
import Taller_Form from "views/Components/ServicesOperationComponent/Taller/Taller_Form";
import { createTheme } from "@mui/material/styles";
import { ThemeProvider } from "@mui/system";

const ServiceOperationTaller_Update = ({ id }) => {
  const divRef = useRef(null);
  const [size, setSize] = useState({ width: 0, height: 0 });

  useEffect(() => {
    const updateSize = () => {
      if (divRef.current) {
        const { width, height } = divRef.current.getBoundingClientRect();
        setSize({ width, height });
      }
    };

    updateSize();
    window.addEventListener("resize", updateSize);
    return () => window.removeEventListener("resize", updateSize);
  }, []);

  const theme = createTheme({
    typography: {
      fontFamily: '"Montserrat", sans-serif',
    },
  });

  return (
    <div style={mainDiv} ref={divRef}>
      <Taller_Form id={id} />
    </div>
  );
};

export default ServiceOperationTaller_Update;

const mainDiv = {
  height: "100%",
  border: "0px solid black",
};
